import { cx } from 'cva';
import { type FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../atoms/Button/Button';
import { Link } from '../../atoms/Link/Link';
import { authSlice } from '../../core/auth/auth.slice';
import { useTranslation } from '../../i18n/resources';
import styles from './LoginForm.module.css';

export type LoginFormProps = {
  className?: string;
};

export const LoginForm: FunctionComponent<LoginFormProps> = ({ className }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const handleClickLogin = useCallback(() => {
    dispatch(authSlice.actions.loginRequested());
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={cx(styles.loginForm, className)}>
          <div>
            <div className={styles.message}>
              <div className={styles.title}>{t('login', 'login_title')}</div>
              <div className={styles.subtitle}>
                {t('login', 'login_subtitle')}
              </div>
            </div>
            <div className={styles.buttonBox}>
              <Button
                className={styles.button}
                color="primary"
                onClick={handleClickLogin}
                size="large"
                type="submit"
              >
                {t('login', 'login')}
              </Button>
              <div className={styles.register}>
                {t('login', 'registered_text')}
                <Link href="https://member.medishare.com/register">
                  {t('login', 'register_link')}
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.join}>
            <div className={styles.message}>
              <div className={styles.joinTitle}>{t('login', 'join_title')}</div>
              <div className={styles.joinSubtitle}>
                {t('login', 'join_subtitle')}
              </div>
            </div>
            <div className={styles.buttonBox}>
              <Button
                asChild
                className={cx(styles.button, styles.joinButton)}
                intent="secondary"
                size="large"
                type="submit"
              >
                <a href="https://www.medishare.com/how-to-join">
                  {t('login', 'join_button')}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
